import {
  AuthProfile,
  AuthProfileDto,
  AuthRole,
  AuthRoleDto,
  AuthSession,
  AuthTokens,
  LoginResponseDto,
  RefreshedTokens,
  RefreshResponseDto,
} from './auth.model';

/**
 * Traduce la respuesta cruda de login (DTO) a la sesión de dominio.
 * Único lugar que conoce el naming mixto (snake/camel) del backend.
 */
export function dtoToSession(dto: LoginResponseDto): AuthSession {
  return {
    tokens: dtoToTokens(dto),
    scope: dto.scope.type,
    profile: dtoToProfile(dto.profile),
  };
}

function dtoToTokens(dto: LoginResponseDto): AuthTokens {
  return {
    accessToken: dto.access_token,
    refreshToken: dto.refresh_token,
    tokenType: dto.token_type,
    sessionId: dto.session_id,
    expiresIn: dto.expires_in,
    expiresAt: dto.expires_at,
    refreshExpiresIn: dto.refreshExpiresIn,
    refreshExpiresAt: dto.refreshExpiresAt,
  };
}

function dtoToProfile(dto: AuthProfileDto): AuthProfile {
  return {
    userId: dto.userId,
    fullName: dto.fullName,
    roleId: dto.roleId,
    roleCode: dto.roleCode,
    roleName: dto.roleName,
    roles: dto.roles.map(dtoToRole),
  };
}

function dtoToRole(dto: AuthRoleDto): AuthRole {
  return { id: dto.roleId, code: dto.roleCode, name: dto.roleName };
}

/** Traduce el par de tokens de un refresh a dominio. */
export function dtoToRefreshedTokens(dto: RefreshResponseDto): RefreshedTokens {
  return { accessToken: dto.access_token, refreshToken: dto.refresh_token };
}

/**
 * Deriva las iniciales (máx. 2) a partir del nombre completo.
 * "Israel Quispe" → "IQ"; un solo nombre → sus 2 primeras letras.
 */
export function initialsFromFullName(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
